module.exports = __webpack_public_path__ + "img/pink-dot.1b91c1a7.svg";